import React, { useState, useRef } from "react";
import { Modal, Button, message, Input, Popconfirm } from "antd";
import PropTypes from "prop-types";
import { deleteRequest, get, post, postFormData } from "../services/base";
import { extractPatientIdFromUrl } from "../utils/helpers";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { handleDescargarArchivo } from "../services/api";

const UploadModal = ({
  isOpen,
  onClose,
  record,
  contexto,
  actualizarDataSource,
}) => {
  const [files, setFile] = useState([]);
  const fileInputRef = useRef(null);
  const [newFileName, setNewFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDeleteFile = async (record) => {
    try {
      const formDataToSend = {
        id: record.id,
        procedencia: contexto,
      };
      await deleteRequest(
        "/Documentacion/archivo",
        JSON.stringify(formDataToSend)
      );
      actualizarDataSource();
      setNewFileName(null);
      onClose();
      message.success("Archivo eliminado.");
    } catch (error) {
      console.error("Error eliminando archivo:", error);
      message.error(
        "Error eliminando archivo. Por favor, inténtelo de nuevo más tarde."
      );
    }
  };

  const handleModalOk = () => {
    if (files) {
      const formData = new FormData();
      const updatedFile = { ...files, name: newFileName };
      formData.append("Archivo", updatedFile.file);
      formData.append("Procedencia", contexto);
      formData.append("Afiliado", extractPatientIdFromUrl());
      formData.append("RegistroId", record.id);
      formData.append("Nombre", updatedFile.name);
      setLoading(true);
      postFormData("/Documentacion/archivo", formData)
        .then((response) => {
          if (!response.status === 200) {
            throw new Error("Error al enviar el archivo");
          }
          message.success(`¡Archivo '${files.name}' subido exitosamente!`);
          actualizarDataSource();
          setNewFileName(null);
          setLoading(false);
          onClose();
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(false);
        });
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const newFile = {
        name: selectedFile.name,
        size: selectedFile.size,
        type: selectedFile.type,
        file: selectedFile,
      };
      setFile(newFile);
      setNewFileName(selectedFile.name);
    }
  };

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      contentLabel="Subir Archivo"
      style={{
        overlay: {
          zIndex: 1041,
          borderRadius: "16px",
          overflow: "hidden",
          padding: "32",
        },
        content: {
          zIndex: 1041,
          width: "600px",
          height: "250px",
          margin: "auto",
        },
      }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button key="save" loading={loading} type="primary" onClick={handleModalOk}>
          Guardar
        </Button>,
      ]}
      centered
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}></div>
      <div>
        <h4>Documentos</h4>
        {files && (
          <>
            <h5>Nombre archivo :</h5>
            <Input
              value={newFileName}
              onChange={(e) => setNewFileName(e.target.value)}
              style={{ marginBottom: "10px" }}
            />
            <ul>
              <li>{newFileName}</li>
            </ul>
          </>
        )}
      </div>
      <div
        style={{
          border: "1px dotted #1E3A8A",
          padding: "10px",
          borderRadius: "5px",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <i className="fas fa-paperclip" style={{ color: "green" }}></i>
        <button
          onClick={handleUploadClick}
          style={{
            border: "none",
            background: "transparent",
            outline: "none",
            marginLeft: "10px",
            color: "green",
          }}
        >
          Cargar Archivo
        </button>
        <input
          ref={fileInputRef}
          type="file"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </div>
      <h5 style={{ textAlign: "center", marginTop: "20px" }}>Documentos:</h5>
      {record &&
        record.documentacion &&
        record.documentacion.length > 0 &&
        record.documentacion.map((archivo, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", marginTop: "8px" }}
          >
            <div
              style={{
                backgroundColor: "var(--primary-blue)",
                color: "#fff",
                padding: "8px",
                width: "100%",
                borderRadius: "4px",
                transition: "background-color 0.3s",
                cursor: "pointer",
              }}
              onClick={() => handleDescargarArchivo(archivo.descripcionDocumentacion)}
            >
              {/* Enlace de descarga del archivo */}
              {archivo.descripcionDocumentacion}
              <Button
                type="link"
                style={{float: "right"}}
                icon={<DownloadOutlined style={{ color: "white" }} />}
              />
              {/* Botón para descargar el archivo */}
            </div>
            <div
              style={{
                marginLeft: "8px",
                height: "100%",
                backgroundColor: "rgb(255, 153, 153)",
                borderRadius: "4px",
                padding: "7px",
                height: "auto",
              }}
            >
              <Popconfirm
                title="¿Está seguro de que desea eliminar este archivo?"
                onConfirm={() => handleDeleteFile(archivo)}
                okText="Sí"
                cancelText="Cancelar"
              >
                <Button
                  type="link"
                  icon={<DeleteOutlined style={{ color: "white" }} />}
                  style={{ padding: 0, height: "100%" }}
                />
              </Popconfirm>
            </div>
          </div>
        ))}
    </Modal>
  );
};

UploadModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default UploadModal;
